export default "__VITE_ASSET__BJqiwibR__"